import React from 'react'
import { connect } from 'react-redux'
import { autorizeAction } from '../../../actions/tiendanubeActions'
import Loader from '../../loaders'
import routes from '../../router/routes'
import { appEnabled } from '../../../server/common'

class Component extends React.Component {
    autorize = () => {
        this.props
            .autorizeAction(this.props.location.search, this.props.history)
            .then((status) => {
                if (appEnabled(status)) {
                    this.props.history.push(routes.orders.path)
                    this.setState({ ready: true })
                }
            })
            .catch((error) => {
                if (error.additionalData)
                    window.showDialog({ message: error.additionalData }, false)
                else window.showDialog(error, false)
            })
    }

    componentDidMount() {
        this.autorize()
    }

    render() {
        return <Loader />
    }
}

const mapDispatchToProps = { autorizeAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
